import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plaintext',
})
export class PlaintextPipe implements PipeTransform {
  constructor() {}
  parser = new DOMParser();

  transform(value: any = ''): any {
    let doc = this.parser.parseFromString(value, 'text/html');
    return doc.body.textContent;
  }
}


@Pipe({
  name: 'plainlength',
})
export class PlainLengthPipe implements PipeTransform {
  constructor() {}
  parser = new DOMParser();

  transform(value: any = ''): any {
    let doc = this.parser.parseFromString(value, 'text/html');
    return doc.body.textContent.replace(/\s/g, '').length;
  }
}
